import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'

$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  $('.section1 .bg-img b').css('transform','translateY('+ scroH / 4 +'px)')
});